<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="600px">
        <el-form ref="form" label-width="auto" label-position="right" :model="dioForm" :rules="rules">
            <template v-if="useFuncId === 2">
                <!-- 网络参数 useFuncId-->

                <!-- 区分六种情况 useFuncType-->

                <!-- zigbee -->
                <template v-if="useFuncType === 1 || useFuncType === 2">
                    <el-form-item :label="$t('Ext Pan ID')" prop="extPanId">
                        <el-input v-model.trim="dioForm.extPanId" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
                    </el-form-item>
                    <el-form-item :label="$t('Join Attemp')" prop="channelPage">
                        <el-input v-model.trim="dioForm.channelPage" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
                    </el-form-item>
                    <el-form-item :label="$t('device.transmit_power')" prop="transmitPower">
                        <el-input v-model.trim="dioForm.transmitPower" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
                    </el-form-item>
                    <el-form-item :label="$t('device.channel_mask')" prop="channelMask">
                        <el-input v-model.trim="dioForm.channelMask" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
                    </el-form-item>
                    <el-form-item :label="$t('device.in_net_interval')" prop="inNetInterval">
                        <el-input v-model.trim="dioForm.inNetInterval" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
                    </el-form-item>
                </template>
                <!-- lora -->
                <template v-else-if="useFuncType === 3 || useFuncType === 4">
                    <el-form-item :label="$t('DevEUI')" prop="devEui">
                        <el-input v-model.trim="dioForm.devEui" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
                    </el-form-item>
                    <el-form-item :label="$t('AppEUI')" prop="appEui">
                        <el-input v-model.trim="dioForm.appEui" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
                    </el-form-item>
                    <el-form-item :label="$t('AppKey')" prop="appKey">
                        <el-input v-model.trim="dioForm.appKey" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
                    </el-form-item>
                    <el-form-item :label="$t('device.channel_mask')" prop="channelMask">
                        <el-input v-model.trim="dioForm.channelMask" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
                    </el-form-item>
                    <el-form-item :label="$t('device.in_net_interval')" prop="inNetInterval">
                        <el-input v-model.trim="dioForm.inNetInterval" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
                    </el-form-item>
                </template>
                <!-- zeta -->
                <template v-else>
                    <el-form-item :label="$t('device.in_net_interval')" prop="inNetInterval">
                        <el-input v-model.trim="dioForm.inNetInterval" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
                    </el-form-item>
                </template>
            </template>
            <template v-else>
                <!-- 上报规则 -->
                <!-- zigbee -->
                <template v-if="useFuncType === 1 || useFuncType === 2">
                    <!-- zigbee湿度 -->
                    <el-form-item :label="$t('device.sample_interval')" prop="collectInterval">
                        <el-input v-model.trim="dioForm.collectInterval" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
                    </el-form-item>
                    <el-form-item :label="$t('device.exception_sample_interval')" prop="exCollectInterval">
                        <el-input v-model.trim="dioForm.exCollectInterval" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
                    </el-form-item>
                </template>
                <!-- lora -->
                <!-- zeta -->
                <template v-else>
                    <el-form-item :label="$t('device.temp_sample_interval')" prop="tempCollectInterval">
                        <el-input v-model.trim="dioForm.tempCollectInterval" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
                    </el-form-item>
                    <el-form-item :label="$t('device.temp_change_threshold')" prop="tempChange">
                        <el-input v-model.trim="dioForm.tempChange" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
                    </el-form-item>
                    <el-form-item :label="$t('device.max_temp_report_interval')" prop="tempMaxReport">
                        <el-input v-model.trim="dioForm.tempMaxReport" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
                    </el-form-item>
                    <el-form-item :label="$t('device.min_temp_report_interval')" prop="tempMinReport">
                        <el-input v-model.trim="dioForm.tempMinReport" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
                    </el-form-item>
                    <!-- lora湿度 -->
                    <template v-if="useFuncType === 4 || useFuncType === 6">
                        <el-form-item :label="$t('device.hum_sample_interval')" prop="humCollectInterval">
                            <el-input v-model.trim="dioForm.humCollectInterval" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
                        </el-form-item>
                        <el-form-item :label="$t('device.hum_change_threshold')" prop="humChange">
                            <el-input v-model.trim="dioForm.humChange" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
                        </el-form-item>
                        <el-form-item :label="$t('device.max_hum_report_interval')" prop="humMaxReport">
                            <el-input v-model.trim="dioForm.humMaxReport" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
                        </el-form-item>
                        <el-form-item :label="$t('device.min_hum_report_interval')" prop="humMinReport">
                            <el-input v-model.trim="dioForm.humMinReport" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
                        </el-form-item>
                    </template>
                </template>
            </template>
        </el-form>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
        </div>
    </modal>
</template>

<script>
import { sensorUpdateNetConfig, sensorUpdateAppConfig } from '@/api/modules/sensor.js'
import addRules from '@/pages/equipment/validate/addRules.js'
export default {
  name: 'NetParam',
  props: ['isShow', 'choozeTableData', 'useFuncId', 'useFuncType'],
  watch: {
    choozeTableData (newVal) {
      this.tableData = [...newVal]
    },
    useFuncId (id) {
      id === 2 ? (this.title = $t('public.net_param')) : (this.title = $t('public.escalation_rules'))
    }
  },
  computed: {
    // 正则不会写啊  难搞
    rules () {
      const rules = addRules.call(this, 'rule', [
        'extPanId',
        'channelPage',
        'channelMask',
        'transmitPower',
        'inNetInterval',
        'devEui',
        'appEui',
        'appKey',
        'collectInterval',
        'exCollectInterval',
        'tempCollectInterval',
        'tempChange',
        'tempMaxReport',
        'tempMinReport',
        'humCollectInterval',
        'humChange',
        'humMaxReport',
        'humMinReport'
      ])
      return rules
    },
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    }
  },
  data () {
    return {
      title: 'public.net_param',
      dioForm: {
        extPanId: null,
        channelPage: null,
        channelMask: null,
        devEui: null,
        appEui: null,
        appKey: null,
        transmitPower: null,
        inNetInterval: null,
        // 上报规则
        tempMaxReport: null,
        tempMinReport: null,
        humMaxReport: null,
        humMinReport: null,
        collectInterval: null,
        exCollectInterval: null,
        // lora
        tempCollectInterval: null,
        tempChange: null,
        humCollectInterval: null,
        humChange: null
      },
      tableData: []
    }
  },
  mounted () {},
  methods: {
    clearValidate () {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    async justify () {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    },
    async handleSave () {
      const flag = await this.justify()
      if (!flag) return
      const idList = this.tableData.map(item => item.id)
      const type = this.tableData[0].type
      const query = Object.assign({}, this.dioForm, { idList, type })
      // 默认网络参数url
      let httpUrl = sensorUpdateNetConfig

      if (this.useFuncId === 3) {
        // 上报规则url
        httpUrl = sensorUpdateAppConfig
      }
      // 去除null
      for (const key in query) {
        if (query[key] === null) {
          delete query[key]
        }
      }
      httpUrl(query).then(({ state }) => {
        if (state.code === 200) {
          this.$message.success($t('integration.update_successful'))
          this.isShowDialog = false
          this.$parent.getListFn()
        } else {
          this.$message.error(state.msg)
        }
      })
    }
  }
}
</script>

<style></style>
